import FontAwesomeIcon from "./FontAwesomeIcon";

export default function PlusIcon({ ...props }) {
  return <FontAwesomeIcon name="plus" {...props} />;
}
